/**
 * ToastContainer component - manages and displays all active toasts
 */

import { Toast } from './Toast';
import type { Toast as ToastType, ToastPosition } from './props/Toast.types';

export interface ToastContainerProps {
  toasts: ToastType[];
  onRemove: (id: string) => void;
  position?: ToastPosition;
}

const positionStyles: Record<ToastPosition, string> = {
  'top-left': 'top-4 left-4 items-start',
  'top-center': 'top-4 left-1/2 -translate-x-1/2 items-center',
  'top-right': 'top-4 right-4 items-end',
  'bottom-left': 'bottom-4 left-4 items-start',
  'bottom-center': 'bottom-4 left-1/2 -translate-x-1/2 items-center',
  'bottom-right': 'bottom-4 right-4 items-end',
};

export function ToastContainer({ toasts, onRemove, position = 'top-right' }: ToastContainerProps) {
  if (toasts.length === 0) {
    return null;
  }

  return (
    <div
      className={`
        fixed z-50 flex flex-col gap-3
        max-w-sm w-full
        pointer-events-none
        ${positionStyles[position]}
      `}
      aria-live="polite"
      aria-atomic="true"
    >
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <Toast toast={toast} onRemove={onRemove} />
        </div>
      ))}
    </div>
  );
}
